module.exports = __webpack_public_path__ + "assets/img/45.2641a813.png";